module.exports = __webpack_public_path__ + "media/images/pc/logo_white-c5477bc2ff6a33d69d28e3716ce3298b.png";